<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <base-form :formData.sync="formData" ref="searchForm">
    <el-form-item >
      <el-button
        :loading="loading.search"
        @click="search('form')"
        type="primary"
      >
        查询
      </el-button>
    </el-form-item>
    <el-form-item >
      <el-button
        @click="reset"
      >
        重置
      </el-button>
    </el-form-item>
    <el-form-item v-if="judgePermission(exportData&&exportData.permissionName)&&exportData">
      <export
        :exportTemplate="exportData&&exportData.exportTemplate"
        :filename="exportData&&exportData.filename"
        :params="getExportParams()"
        />
    </el-form-item >
    <el-form-item>
      <slot name="custom-export"> </slot>
    </el-form-item>
</base-form>
</template>
<script>
import get from 'lodash/get'
import { useAutoQuery } from '@/utils/useAutoQuery'

export default {
  name: 'SearchForm',
  props: ['formData', 'oLoading'],
  data() {
    const {
      exportData,
    } = this.formData
    return {
      exportData,
      loading: {},
      pagination: false,
      sorter: null,
    }
  },
  inject: ['activeAutoQuery'],
  methods: {
    getExportParams() {
      const { formData, getSearchParams } = this
      const exportPageParams = {
        pageNum: get(this.pagination, 'pageNum'),
        pageSize: get(this.pagination, 'pageSize'),
      }
      return formData && formData.formProps && formData.formProps.model && { ...getSearchParams(), ...exportPageParams }
    },
    // 设置分页&表格排序
    // eslint-disable-next-line vue/no-unused-properties
    setPagination({ pagination, sorter }) {
      if (typeof (pagination) !== 'boolean') {
        this.pagination = pagination
      }
      this.sorter = sorter
    },

    // 表单搜索
    search(type = 'form', isReset) {
      const { pagination } = this
      const { search, customHandingEvents, clickSearch } = this.formData
      // 搜索需要的公共参数
      const searchParams = { pagination: this.pagination, searchParams: this.getSearchParams(isReset, true) }
      if (isReset === 'reset' && searchParams.searchParams.sorter) { delete searchParams.searchParams.sorter }
      if (type === 'form' && typeof (this.pagination) !== 'boolean') {
        this.pagination.pageNum = 1
        // 点击搜索时执行，普通翻页不执行
        if (clickSearch && typeof (clickSearch) === 'function') { clickSearch() }
      }
      if (search) { // 存在自定义搜索方法，包括参数重组和调用接口方法
        let params = {}
        if (typeof (pagination) !== 'boolean') {
          params = {
            pageNum: type === 'form' ? 1 : pagination.pageNum,
            pageSize: pagination.pageSize,
          }
        }

        search({ ...searchParams, pagination: { ...pagination, ...params } })
        return
      }
      if (customHandingEvents && typeof customHandingEvents === 'function') {
        customHandingEvents()
      }
      // if (dealWithSearch) { // 仅仅处理参数，返回正确的数据用来调用接口
      //   this.$emit('paginationChange', { ...searchParams })
      //   return
      // }
      this.$emit('paginationChange', searchParams)
    },

    // 获取请求参数
    getSearchParams(isReset, updateQuery) {
      const { dealWithSearch } = this.formData
      let searchParams = {}
      const { formProps: { model } } = this.formData
      searchParams = Object.assign({}, model, this.sorter && !isReset ? { sorter: this.sorter } : {})
      if (updateQuery && this.activeAutoQuery) {
        const aq = useAutoQuery()
        const filter = {}
        for (const key in searchParams) {
          if (Object.hasOwnProperty.call(searchParams, key)) {
            filter[key] = searchParams[key]
          }
        }
        aq.f = filter
      }
      if (dealWithSearch) {
        // dealWithSearch 仅做搜索参数处理
        searchParams = dealWithSearch(searchParams)
      }
      return searchParams
    },

    // 重置
    reset() {
      const { customizeReset } = this.formData
      this.$refs.searchForm.reset()
      if (customizeReset && typeof customizeReset === 'function') {
        customizeReset()
      }
      this.$nextTick(() => {
        this.search('form', 'reset')
      })
    },
  },
  mounted() {
    this.loading = Object.assign({ search: false }, this.oLoading, this.formData.oLoading)
  },
}
</script>

<style lang="scss" scoped>
.mr8{
  margin-right:8px
}
</style>
